import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './division-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import DivisionPicklist from '../division/division-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class DivisionCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
      
    private onLoadParent = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'parent': data?.id, 'parentCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} onError={this.onError}>               
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                <Input name='location' label='Location (Building, Floor, Room)' value={this.state.datarow.location} error={this.state.errors?.location} onChange={this.onChange} />
                <InputPicklist name='parent' label='Parent' value={this.state.datarow.parent} caption={this.state.datarow.parentCaption} error={this.state.errors?.parent} clearValue={this.onLoadParent} onChange={this.onChange} >
                    <DivisionPicklist currentId={this.state.datarow.parent} onLoad={this.onLoadParent}/>                    
                </InputPicklist>


            </BaseCreate>
        );
    }     
     
}